import classNames from 'classnames/bind';
import styles from './TiktokPreview.module.scss';
import images from '~/assets';
import { useState, useEffect, useRef, useContext } from 'react';
import useVisibility from '~/hooks/useVisibility';
import { FaHeart, FaComment, FaShare, FaUserFriends } from 'react-icons/fa';
import GifViewer from '~/component/GifViewer';
import Img from '~/component/Img';
import { ThemeModeContext } from '~/component/Context/ThemeModeProvider';
import { useDarkMode } from '~/hooks/useDarkMode';

const cx = classNames.bind(styles);

function TiktokPreview() {
  const wrapperRef = useRef(null);
  const isVisible = useVisibility(wrapperRef);
  const { theme } = useContext(ThemeModeContext);
  const [isDarkMode, setIsDarkMode] = useState(useDarkMode());

  useEffect(() => {
    setIsDarkMode(theme === 'dark' ? true : false);
  }, [theme]);

  return (
    <div ref={wrapperRef} className={cx('wrapper', { visible: isVisible })}>
      <div className={cx('container')}>
        <h2 className={cx('title')}>Kênh TikTok của tôi</h2>
        <div className={cx('content')}>
          <GifViewer src={images.airplane} classNames={cx('may-bay')} />
          {isDarkMode ? (
            <Img src={images.tiktok2Dark} className={cx('tiktok-logo')} />
          ) : (
            <Img src={images.tiktok2} className={cx('tiktok-logo')} />
          )}
          <div className={cx('screenshot')}>
            <div className={cx('image-container')}>
              <img src={images.tiktokScreen} alt="TikTok Channel Screenshot" className={cx('image')} />
            </div>
            {/* <div className={cx('secondary-image')}>
              <img src={images.avttiktok} alt="TikTok Profile" className={cx('profile-image')} />
              <div className={cx('profile-info')}>
                <span className={cx('profile-name')}>@qngok4</span>
                <span className={cx('profile-stats')}>0.776K Followers</span>
              </div>
            </div> */}
          </div>
          <div className={cx('info')}>
            <h3 className={cx('channel-name')}>id: @qngok4</h3>
            <div className={cx('stats')}>
              <div className={cx('stat-item')}>
                <FaHeart className={cx('stat-icon')} />
                <span className={cx('stat-value')}>70.3K</span>
                <span className={cx('stat-label')}>Likes</span>
              </div>
              <div className={cx('stat-item')}>
                <FaComment className={cx('stat-icon')} />
                <span className={cx('stat-value')}>{">4k"}</span>
                <span className={cx('stat-label')}>Comments</span>
              </div>
            </div>
            <p className={cx('description')}>
              <GifViewer src={images.longga} classNames={cx('long-ga')} />
              Ngoài là một lập trình viên suốt ngày cắm đầu vào code, tôi còn là một nhà sáng tạo nội dung không có nội
              dung cố định tại TikTok. Hãy theo dõi để xem thêm nhiều video hấp dẫn nhé!
            </p>
            <div className={cx('action-buttons')}>
              <a
                href="https://www.tiktok.com/@qngok4"
                target="_blank"
                rel="noopener noreferrer"
                className={cx('follow-button')}
              >
                Theo dõi trên TikTok
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TiktokPreview;
